import { Backdrop, Box, CircularProgress } from '@mui/material';

export interface BlockerLoaderProps {
    isLoading: boolean;
}

const BlockerLoader = ({ isLoading }: BlockerLoaderProps) => {
    return (
        <Backdrop
            open={isLoading}
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: 'absolute',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
            }}
        >
            <Box sx={{ textAlign: 'center' }}>
                <CircularProgress color="inherit" size={60} />
            </Box>
        </Backdrop>
    );
};

export default BlockerLoader;
